var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V22.5H0z",
    transform: "translate(-122 -387) translate(110 236) translate(0 114) translate(0 26) translate(12 10.25) translate(0 .75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2447",
    d: "M1.6 4.5c-.22 0-.4.204-.4.455v12.29c0 .251.18.455.4.455h16.8c.22 0 .4-.204.4-.455V4.955c0-.251-.18-.455-.4-.455H1.6zm.92.91h14.902l-3.457 3.347-.003.003-3.938 3.89-3.938-3.89-.007-.007L2.52 5.41zM18 6.046V16.79H2V6.102l3.568 3.351 4.194 4.144c.15.148.374.148.524 0l4.197-4.146.002-.002.001-.001L18 6.046z",
    transform: "translate(-122 -387) translate(110 236) translate(0 114) translate(0 26) translate(12 10.25) translate(0 .75)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogin);
export default __webpack_public_path__ + "static/media/email-login.a78908a4.svg";
export { ForwardRef as ReactComponent };